/* eslint-disable jsx-a11y/control-has-associated-label */
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React, { useState } from 'react';
import { node } from 'prop-types';

// @ancert imports
import { AUIModal } from '@ancert/aui-modal';

import { ReactComponent as LogoPNC } from '../../assets/images/logoPNC.svg';
import { ReactComponent as LogoCTN } from '../../assets/images/logoCTN.svg';
import { ReactComponent as LogoConsejo } from '../../assets/images/logoConsejo.svg';

import './styles.scss';

/**
 * Componente que genera el Layout
 *
 * @component
 * @param {import('../../interfaces/containers/layout.interface').LayoutProps} props - Propiedades del componente
 * @returns {React.ReactElement} - Devuelve un componente Layout
 */
export default function Layout({ children }) {
  const [browsersModal, setBrowsersModal] = useState(false);

  return (
    <div className="layout">
      <header>
        <div className="header-sede-electronica">SEDE ELECTRÓNICA NOTARIAL</div>
        <div className="sub-header">
          <a href={`${window.location.origin}/portal/`} title="Ir a Portal del Ciudadano">
            <LogoPNC className="header-logo" />
          </a>
        </div>
      </header>
      <main>{children}</main>
      <footer>
        <a href="https://www.notariado.org" className="footer-logo">
          <LogoConsejo className="logos-footer" />
        </a>
        <div className="advise-text">
          <div className="texto-notariado">© {new Date().getFullYear()}, Consejo General del Notariado</div>
          <div className="avisos">
            <a href="/portal/web/guest/aviso-legal" aria-hidden className="link">
              Aviso Legal
            </a>
            <span className="separator">|</span>
            <a href="/portal/web/guest/politica-de-privacidad" aria-hidden className="link">
              Política de privacidad
            </a>
            <span className="separator">|</span>
            <a href="/portal/web/guest/accesibilidad" aria-hidden className="link">
              Accesibilidad
            </a>
            <span className="separator">|</span>
            <a href="/portal/web/guest/politica-de-cookies" aria-hidden className="link">
              Política de cookies
            </a>
            <span className="separator">|</span>
            <a onClick={() => setBrowsersModal(true)} aria-hidden className="link">
              Navegadores soportados
            </a>
          </div>
        </div>
        <a href="https://www.ctnotariado.com/liferay/web/ancert/inicio" className="footer-logo">
          <LogoCTN className="logos-footer" />
        </a>
      </footer>
      <AUIModal
        show={browsersModal}
        onClose={() => {
          setBrowsersModal(false);
        }}
        title="Navegadores soportados:"
        size="xs"
        className="browsers-modal"
      >
        <div className="content">
          <ul className="list">
            <li>Chrome</li>
            <li>Firefox</li>
            <li>Microsoft Edge</li>
            <li>Safari</li>
          </ul>
          <div className="other">Puedes acceder utilizando un PC, Mac, móvil o tableta.</div>
        </div>
      </AUIModal>
    </div>
  );
}

Layout.propTypes = {
  children: node.isRequired,
};
